import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isInitialized: false,
  isVisible: true,
  sessionId: null,
  lastMerchantId: null
};

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setChatInitialized: (state, action) => {
      state.isInitialized = action.payload;
    },
    setChatVisible: (state, action) => {
      state.isVisible = action.payload;
    },
    setSessionId: (state, action) => {
      state.sessionId = action.payload;
    },
    setLastMerchantId: (state, action) => {
      state.lastMerchantId = action.payload;
    },
    resetChat: (state) => {
      state.isInitialized = false;
      state.sessionId = null;
      state.lastMerchantId = null;
    }
  }
});

export const {
  setChatInitialized,
  setChatVisible,
  setSessionId,
  setLastMerchantId,
  resetChat
} = chatSlice.actions;

export default chatSlice.reducer;
